import { render, staticRenderFns } from "./AntifraudLastActivation.vue?vue&type=template&id=97644e5c&"
import script from "./AntifraudLastActivation.vue?vue&type=script&lang=js&"
export * from "./AntifraudLastActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports